<div class="d-flex justify-content-center align-items-center w-100 h-100">
  <img src="assets/img/images/home.png" alt="" class="img-fluid maintenance-img" style="width: 100%; height: auto; object-fit: cover;">
</div>
